import { render, staticRenderFns } from "./parentChildrenRewards.vue?vue&type=template&id=9f3117dc&scoped=true&"
import script from "./parentChildrenRewards.vue?vue&type=script&lang=js&"
export * from "./parentChildrenRewards.vue?vue&type=script&lang=js&"
import style0 from "./parentChildrenRewards.vue?vue&type=style&index=0&id=9f3117dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3117dc",
  null
  
)

export default component.exports